import { qualifyUrls } from "routing/Routes";
const AwsRoutes = {
  INTEGRATIONS: {
    AWS: {
      CLOUDWATCH: {
        index: "/integrations/aws/cloudwatch"
      }
    }
  }
};
const ApiRoutes = {
  INTEGRATIONS: {
    AWS: {
      REGIONS: "/plugins/org.graylog.integrations/aws/regions",
      CLOUDWATCH: {
        GROUPS: "/plugins/org.graylog.integrations/aws/cloudwatch/log_groups"
      },
      KINESIS: {
        HEALTH_CHECK: "/plugins/org.graylog.integrations/aws/kinesis/health_check",
        STREAMS: "/plugins/org.graylog.integrations/aws/kinesis/streams",
        STREAM_ARN: "/plugins/org.graylog.integrations/aws/kinesis/stream_arn",
        SAVE: "/plugins/org.graylog.integrations/aws/inputs?setup_wizard=true"
      },
      KINESIS_AUTO_SETUP: {
        CREATE_STREAM: "/plugins/org.graylog.integrations/aws/kinesis/auto_setup/create_stream",
        CREATE_SUBSCRIPTION_POLICY: "/plugins/org.graylog.integrations/aws/kinesis/auto_setup/create_subscription_policy",
        CREATE_SUBSCRIPTION: "/plugins/org.graylog.integrations/aws/kinesis/auto_setup/create_subscription"
      }
    }
  }
};
const DocsRoutes = {
  INTEGRATIONS: {
    AWS: {
      AWS_KINESIS_CLOUDWATCH_INPUTS: "aws-kinesiscloudwatch-input"
    }
  }
};
export default {
  ...qualifyUrls(AwsRoutes),
  unqualified: AwsRoutes
};
export { ApiRoutes, DocsRoutes };
